import React from 'react';
import { Link } from 'react-router-dom';
import { RemoteImg } from './RemoteMedia';

export default function CardItem({ to, title, subtitle, meta, image, imageAlt, badge, progress = 0, buttonLabel = 'Học ngay', disabled=false, onClick, actions, noLink=false, linkState }) {
  const Container = (!disabled && !noLink) ? Link : 'div';
  const containerProps = (!disabled && !noLink) ? { to: to || '#', state: linkState } : {};
  return (
    <Container {...containerProps} className="block" onClick={disabled ? onClick : undefined}>
      <div className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-200 p-5 h-full flex flex-col justify-between cursor-pointer">
        <div className="flex items-start gap-4">
          {image ? (
            <div className="flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden bg-gray-100 flex items-center justify-center">
              <RemoteImg src={image} width={80} alt={imageAlt || title} className="object-cover w-full h-full" />
            </div>
          ) : (
            <div className="flex-shrink-0 w-20 h-20 rounded-lg bg-gray-100" />
          )}

          <div className="flex-1">
            <div className="flex items-start justify-between">
              <div className="pr-4">
                <h3 className="text-lg md:text-xl font-bold text-gray-900 leading-tight">{title}</h3>
                {subtitle ? <p className="text-sm text-gray-500 mt-1 line-clamp-2">{subtitle}</p> : null}
              </div>
              {badge ? (
                <span className="ml-2 text-xs bg-blue-50 text-blue-600 px-2 py-1 rounded-full shadow-sm">{badge}</span>
              ) : null}
            </div>

            <div className="mt-4">
              <div className="w-full bg-gray-200 rounded-full h-2.5">
                <div className="bg-gray-300 h-2.5 rounded-full" style={{ width: `${Math.max(0, Math.min(100, progress))}%` }}></div>
              </div>
            </div>

            <div className="mt-4 flex items-center justify-between">
              <div className="text-sm text-gray-500">{actions ? actions : meta}</div>
              <div className="flex items-center gap-3">
                {badge && <span className="text-xs bg-[#e6f6ff] text-blue-600 px-2 py-1 rounded">{badge}</span>}
                {disabled ? (
                  <button onClick={(e)=>{e.preventDefault(); e.stopPropagation(); onClick && onClick();}} className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg shadow">{buttonLabel}</button>
                ) : (
                  (noLink && to) ? (
                    <Link to={to} state={linkState} onClick={(e)=>e.stopPropagation()}>
                      <button className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg shadow">{buttonLabel}</button>
                    </Link>
                  ) : (
                    <button className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg shadow">{buttonLabel}</button>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
}
